import React from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import Moment from "react-moment";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const DeletedRepeatEvent = ({ Show, Hide, Title, tableRef, onMouseDown, deletedRepeatEventLoader, deletedRepeatEventList, restoreStudySubjectRepeatEvent }) => {
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: "600px" }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {deletedRepeatEventLoader ? (
          <PageLoader />
        ) : deletedRepeatEventList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Repeated Event not deleted yet."} />
          </div>
        ) : (
          <Table className="m-0 custom-table" hover striped ref={tableRef}>
            <thead className="position-sticky top-0 z-1">
              <tr>
                <th onMouseDown={(e) => onMouseDown(e, 0)} style={{ width: 45 }} className="text-center">
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Event</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)} style={{ width: 60 }} className="text-center">
                  Repeat
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 3)}>Deleted By</th>
                <th onMouseDown={(e) => onMouseDown(e, 4)}>Deleted At</th>
                <th onMouseDown={(e) => onMouseDown(e, 5)} style={{ width: 60 }} className="text-center">
                  Restore
                </th>
              </tr>
            </thead>
            <tbody>
              {deletedRepeatEventList?.map((row, index) => (
                <tr key={row?.repeatEventId || index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{row?.eventName}</td>
                  <td className="text-center">R{row?.repeatNumber}</td>
                  <td>{row?.deletedByName || "-"}</td>
                  <td>
                    {row?.deletedAt ? (
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {row?.deletedAt}
                      </Moment>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="text-center" title={`Restore ${row?.eventName} (R${row?.repeatNumber})`}>
                    <MdRestore
                      style={{ fontSize: 16 }}
                      className="text-success CP"
                      onClick={() => restoreStudySubjectRepeatEvent(row)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DeletedRepeatEvent;
